import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-course-description',
  templateUrl: './course-description.component.html',
  styleUrls: ['../grades.component.css']
})
export class CourseDescriptionComponent implements OnInit {
  course = '';
  subjectSection = '';
  teacher = '';
  school = '';
  curriculum = '';
  description = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CourseDescriptionComponent>
  ) { }

  ngOnInit() {
    this.course = this.data.studentSchedule.Course;
    this.subjectSection = this.data.studentSchedule.SubjectCode + '-' + this.data.studentSchedule.Section;
    this.teacher = this.data.studentSchedule.Teacher;
    this.school = this.data.studentSchedule.SchoolName;
    this.curriculum = this.data.studentSchedule.Curriculum;
    this.description = this.data.studentSchedule.Description;
  }

  closeClick() {
    this.dialogRef.close('Close was clicked.');
  }
}
